import { useMemo } from "react";
// @ts-expect-error pure js
import useGroupBy from "./use-group-by";
import { getBalanceParentId } from "../utils/balances";

interface BalanceLike {
  correlation_id?: string;
  domaine?: string;
  montant: number;
  date_transac: string;
  type: string;
  id_transaction?: number;
  comment?: string;
  file?: object;
  balances?: BalanceLike[];
}

export default function useGroupedBalances<T extends BalanceLike>(
  balances: T[],
  domaineBalance: string,
  parentId: number | string,
): T[] {
  const balancesByCorrelationId = useGroupBy(balances, {
    attr: "correlation_id",
  }) as Record<string, T[]>;

  return useMemo(() => {
    const seen = new Set<string>();
    const grouped: T[] = [];

    balances.forEach((balance) => {
      if (
        !balance.correlation_id ||
        (balance.domaine === domaineBalance &&
          getBalanceParentId(balance) === parentId)
      ) {
        grouped.push(balance);
        return;
      }

      if (seen.has(balance.correlation_id)) return;
      const related = balancesByCorrelationId[balance.correlation_id];

      grouped.push({
        montant: related.reduce((sum, b) => sum + b.montant, 0),
        date_transac: related[0].date_transac,
        type: related[0].type,
        balances: related,
        id_transaction: related[0].id_transaction,
        comment: related[0].comment,
        correlation_id: balance.correlation_id,
        domaine: domaineBalance,
        file: related[0].file,
      } as unknown as T);
      seen.add(balance.correlation_id);
    });

    return grouped;
  }, [balances, balancesByCorrelationId, domaineBalance, parentId]);
}
